(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/wager/middleware-payment-confirm/assets/payment-confirm.js') >= 0) return;  svs.modules.push('/components/wager/middleware-payment-confirm/assets/payment-confirm.js');
'use strict';

const {
  logger
} = svs.components.wager.common;
const {
  Currency: currency
} = svs.utils.format;
const {
  getAccountBalance
} = svs.components.marketplaceShared.getBalance;
const {
  groupTypes
} = svs.components.marketplaceData.constants;
const getProductsString = wagers => {
  const products = [...new Set(wagers.reduce((products, wager) => products.concat(wager.getProductsInBet()), []))];
  if (products.length === 1) {
    return products.join('');
  }
  return "".concat(products.slice(0, -1).join(', '), " och ").concat(products.slice(-1).pop());
};
const paymentConfirm = onInteraction => _ref => {
  let {
    wagers
  } = _ref;
  return async next => {
    try {
      const allWagers = wagers.getWagers();
      const marketplaceWager = allWagers.find(wager => wager.activatedDrawId);
      let marketplaceDrawName;
      let role;
      if (marketplaceWager) {
        var _marketplaceDraw$data, _marketplaceDraw$data2;
        role = marketplaceWager === null || marketplaceWager === void 0 ? void 0 : marketplaceWager.role;
        const activatedDrawId = marketplaceWager.activatedDrawId;
        const productId = marketplaceWager.bets[0].productId;
        const drawNumber = marketplaceWager.bets[0].drawNumber;
        const marketplaceDraw = await getAccountBalance.getBalance(role, productId, drawNumber, activatedDrawId, false);
        marketplaceDrawName = role === groupTypes.PRIVATE ? marketplaceDraw === null || marketplaceDraw === void 0 || (_marketplaceDraw$data = marketplaceDraw.data) === null || _marketplaceDraw$data === void 0 ? void 0 : _marketplaceDraw$data.GroupName : marketplaceDraw === null || marketplaceDraw === void 0 || (_marketplaceDraw$data2 = marketplaceDraw.data) === null || _marketplaceDraw$data2 === void 0 ? void 0 : _marketplaceDraw$data2.name;
      }
      const productsStr = getProductsString(allWagers);
      const price = wagers.getTotalPrice();
      const wagerCount = wagers.count();
      const gamesStr = wagerCount > 1 ? 'dina' : 'ett';
      const title = "Vill du betala ".concat(gamesStr, " spel p\xE5 ").concat(productsStr, " f\xF6r ").concat(currency(price), " kr").concat(marketplaceDrawName ? " \xE5t ".concat(marketplaceDrawName) : '', "?");
      await onInteraction({
        title,
        wagerCount,
        role
      });
      next();
    } catch (err) {
      logger.debug(err === null || err === void 0 ? void 0 : err.message, err);
    }
  };
};

setGlobal('svs.components.wager.middleware.paymentConfirm', paymentConfirm);

 })(window);